import { createRouteRef } from '@backstage/core-plugin-api';

export const budgetRouteRef = createRouteRef({
  id: 'aws-finops-frontend/budget',
});

export const costRecommendationRouteRef = createRouteRef({
  id: 'aws-finops-frontend/cost-recommendation',
});
